<script setup lang="ts">
import {
	CREDIT_INPUT_LIMITS,
	formatBrl,
	formatPercent,
	formatPlainInput,
	HOME_EQUITY_MONTHLY_RATE,
	useCreditSimulator
} from '~/composables/credit';

import CreditSimulatorAmountField from './CreditSimulatorAmountField.vue';
import CreditSimulatorSummary from './CreditSimulatorSummary.vue';

const simulator = useCreditSimulator();
const inputs = computed(() => simulator.state.value.inputs);
const result = simulator.homeEquity;

const summaryItems = computed(() => [
	{ label: 'Crédito liberado', value: formatBrl(result.value.credit) },
	{
		label: 'Taxa de referência',
		value: `${formatPercent(HOME_EQUITY_MONTHLY_RATE * 100, 2)} a.m.`
	}
]);
</script>

<template>
	<div class="flex flex-col gap-4.5">
		<CreditSimulatorAmountField
			label="Valor do seu imóvel"
			range-id="h-valor"
			text-id="h-valor-n"
			text-label="Valor do imóvel em reais"
			:amount-value="inputs.homeEquityValue"
			:range-value="inputs.homeEquityValue"
			v-bind="CREDIT_INPUT_LIMITS.homeEquityValue"
			@amount="simulator.setInput('homeEquityValue', $event)"
			@commit="simulator.commitInput('homeEquityValue')"
			@slide="simulator.setInput('homeEquityValue', $event)"
		/>
		<CreditSimulatorAmountField
			:label="`Quanto quer levantar (${Math.round(inputs.homeEquityPercent)}%)`"
			range-id="h-pct"
			text-id="h-cred-n"
			text-label="Valor do crédito em reais"
			:amount-value="result.credit"
			:range-value="inputs.homeEquityPercent"
			v-bind="CREDIT_INPUT_LIMITS.homeEquityPercent"
			@amount="
				simulator.setPercentFromAmount(
					'homeEquityPercent',
					'homeEquityValue',
					$event
				)
			"
			@commit="simulator.commitInput('homeEquityPercent')"
			@slide="simulator.setInput('homeEquityPercent', $event)"
		/>
		<CreditSimulatorAmountField
			label="Prazo"
			range-id="h-prazo"
			text-id="h-prazo-n"
			text-label="Prazo em meses"
			unit="meses"
			:text-value="formatPlainInput(inputs.homeEquityMonths)"
			:range-value="inputs.homeEquityMonths"
			v-bind="CREDIT_INPUT_LIMITS.homeEquityMonths"
			@type="simulator.typeInput('homeEquityMonths', $event)"
			@commit="simulator.commitInput('homeEquityMonths')"
			@slide="simulator.setInput('homeEquityMonths', $event)"
		/>
		<CreditSimulatorSummary
			:headline="{
				label: 'Parcela mensal estimada',
				value: formatBrl(result.installment)
			}"
			:items="summaryItems"
		/>
		<div class="text-[12px] text-[#8A8A8A]">
			Imóvel quitado ou quase quitado. Bancos liberam até cerca de 60% do valor
			de avaliação. Não inclui IOF, seguros e correção.
		</div>
	</div>
</template>
